// removed by extract-text-webpack-plugin
module.exports = {"toastContainer":"styles__toastContainer___Jl3nf"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/toast/styles.css
// module id = 3jnV
// module chunks = 2